import { render, staticRenderFns } from "./ImgUpload2.vue?vue&type=template&id=16b73062&scoped=true"
import script from "./ImgUpload2.vue?vue&type=script&lang=js"
export * from "./ImgUpload2.vue?vue&type=script&lang=js"
import style0 from "./ImgUpload2.vue?vue&type=style&index=0&id=16b73062&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b73062",
  null
  
)

export default component.exports